// extracted by mini-css-extract-plugin
export default {"btn_label":"ContentTypeButtonMenu_btn_label__cZPKP","menu_item_label":"ContentTypeButtonMenu_menu_item_label__5H8U5","menu_icon":"ContentTypeButtonMenu_menu_icon__Mieo4"};